import login from './login';
import home from './home';
import project from './project';
import unauthorized from './unauthorized';
import smsValidation from '@/translations/fr/views/smsValidation';
import patient from '@/translations/fr/views/patient';
import patientExperienceSurvey from '@/translations/fr/views/patientExperienceSurvey';
import patientExperienceUnsubscribe from '@/translations/fr/views/patientExperienceUnsubscribe';
import payment from '@/translations/fr/views/payment';
import patientFile from '@/translations/fr/views/patientFile';
import actors from '@/translations/fr/views/actors';
import genericImport from '@/translations/fr/views/genericImport';
import projectExport from '@/translations/fr/views/projectExport';
import usersActors from '@/translations/fr/views/usersActors';
import idelActors from '@/translations/fr/views/idelActors';
import dataLine from '@/translations/fr/views/dataLine';
import projectGroup from '@/translations/fr/views/projectGroup';
import campaign from '@/translations/fr/views/campaign';

export default {
	login,
	home,
	project,
	unauthorized,
	smsValidation,
	patient,
	patientFile,
	patientExperienceSurvey,
	patientExperienceUnsubscribe,
	payment,
	actors,
	genericImport,
	projectExport,
	usersActors,
	idelActors,
	dataLine,
	projectGroup,
	campaign
};
